import { useTranslation } from 'react-i18next'
import { MAX_PHOTO_BOOK_PAGES } from '@mixtiles/web-backend-shared'
import { ActionPopup } from 'components/Popup/ActionPopup'
import { SCREENS } from 'services/Analytics/Analytics'
import type { PhotoBookCartItem } from 'stores/cartStore/CartItem'

export function TooManyPagesPopup({
  open,
  book,
  onDismiss,
  onEditBookTap,
}: {
  open: boolean
  book: PhotoBookCartItem
  onDismiss: () => void
  onEditBookTap: () => void
}) {
  const { t } = useTranslation()
  const { size, photosCount } = book.metadata

  return (
    <ActionPopup
      popupName="Too Many Pages"
      open={open}
      imageComponent={null}
      showCloseButton
      onClose={onDismiss}
      mainText={t('photo_book.too_many_pages.title')}
      secondaryText={t('photo_book.too_many_pages.subtitle', {
        maxPhotos: MAX_PHOTO_BOOK_PAGES,
        extraPhotos: photosCount - MAX_PHOTO_BOOK_PAGES,
      })}
      approveText={t('photo_book.too_many_pages.cta')}
      onApproveTap={onEditBookTap}
      analyticsProps={{
        Source: SCREENS.CART_DRAWER,
        'Book ID': book.id,
        'Book Size': size,
        'Photo Count': photosCount,
      }}
      titleMaxWidth={300}
    />
  )
}
